import React from 'react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    value: string;
    label: string;
  }[];
}
export function Select({
  label,
  error,
  options,
  className = '',
  ...props
}: SelectProps) {
  return <div className="w-full" data-id="element-485" data-mp="2640ubwqzj5py">
      {label && <label className="block text-sm font-medium text-stone-700 mb-1.5" data-id="element-486" data-mp="265bxbuclw9g0">
          {label}
        </label>}
      <select className={`w-full px-4 py-2.5 rounded-lg border border-stone-200 bg-white text-stone-900 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all ${error ? 'border-red-400' : ''} ${className}`} {...props} data-id="element-487" data-mp="32w4g4zqxcflh">
        {options.map(option => <option key={option.value} value={option.value} data-id="element-488" data-mp="2p0sjgmt7kf1x">
            {option.label}
          </option>)}
      </select>
      {error && <p className="mt-1.5 text-sm text-red-600" data-id="element-489" data-mp="3gtjcypjibpnh">{error}</p>}
    </div>;
}